"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const dialog_handler_1 = require("./dialog-handler");
const image_properties_app_1 = require("./image-properties-app");
const content_blocks_replace_variables_1 = require("@emartech/content-blocks-replace-variables");
const html_custom_element_1 = require("../../lib/html-custom-element");
const reactive_decorators_1 = require("../../lib/reactive-decorators");
const custom_element_decorators_1 = require("../../lib/custom-element-decorators");
const translate_1 = require("./translate");
exports.createImagePropertiesDialog = (render, translate) => {
    class ImagePropertiesDialog extends html_custom_element_1.HTMLCustomElement {
        open(data, editableId) {
            return new Promise(resolve => {
                const translateKey = translate(this.translations || {});
                const dialogHandler = dialog_handler_1.DialogHandler.create(translateKey);
                const { headerContainer, contentContainer } = dialogHandler.openDialog();
                const getPropertiesAppState = render({
                    headerContainer,
                    contentContainer,
                    data,
                    translate: translateKey,
                    replaceVariables: content_blocks_replace_variables_1.replaceVariables(this.variables || {}),
                    trackEvent: this._track.bind(this),
                    openMediaDbApi: this._openMediaDb.bind(this),
                    validate: this._validate.bind(this),
                    tabs: this._tabs,
                    editableId,
                });
                dialogHandler.once('apply', () => {
                    return resolve(getPropertiesAppState());
                });
            });
        }
        _validate({ validationState, }) {
            return this._tabs.reduce((state, tab) => {
                state[tab.name] = tab.warningStrategies
                    .map(ws => !ws.validate
                    ? undefined
                    : ws.validate({
                        tabName: tab.name,
                        validationState,
                    }))
                    .filter(warning => warning !== undefined);
                return state;
            }, {});
        }
        _track(action, label) {
            this.dispatchEvent(new CustomEvent('vceimagepropertiesdialog.trackevent', {
                bubbles: true,
                detail: {
                    action,
                    label,
                },
            }));
        }
        _openMediaDb() {
            if (!this._$openMediaDb) {
                throw new Error('missing open media db handler');
            }
            return this._$openMediaDb.open().then(({ relativePath, basePath }) => `${basePath}${relativePath}`);
        }
    }
    __decorate([
        reactive_decorators_1.JsonAttribute('translations'),
        __metadata("design:type", Object)
    ], ImagePropertiesDialog.prototype, "translations", void 0);
    __decorate([
        reactive_decorators_1.JsonAttribute('variables'),
        __metadata("design:type", Object)
    ], ImagePropertiesDialog.prototype, "variables", void 0);
    __decorate([
        reactive_decorators_1.ViewChildren('vce-image-properties-dialog-tab'),
        __metadata("design:type", Array)
    ], ImagePropertiesDialog.prototype, "_tabs", void 0);
    __decorate([
        reactive_decorators_1.ViewChild('[open-media-db]'),
        __metadata("design:type", Object)
    ], ImagePropertiesDialog.prototype, "_$openMediaDb", void 0);
    return ImagePropertiesDialog;
};
exports.name = 'vce-image-properties-dialog';
custom_element_decorators_1.CustomElement(exports.name)(exports.createImagePropertiesDialog(image_properties_app_1.render, translate_1.translate));
//# sourceMappingURL=image-properties-dialog.component.js.map